export const CAROUSEL_DEFAULT_OPTS = ({
    modules,
    $prevButton,
    $nextButton,
    updateCallback,
    isPrefersReducedMotion = false
}) => {
    return {
        modules: modules,
        speed: isPrefersReducedMotion ? 0 : 400,
        effect: isPrefersReducedMotion ? 'fade' : 'slide',
        loop: false,
        slidesPerView: 1.1,
        spaceBetween: 10,
        navigation: {
            prevEl: $prevButton,
            nextEl: $nextButton
        },
        breakpoints: {
            700: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            1000: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        },
        on: {
            init: updateCallback ? updateCallback : () => {},
            breakpoint: updateCallback ? updateCallback : () => {},
            destroy: updateCallback ? updateCallback : () => {}
        }
    };
};

export const CAROUSEL_HERO_NEWS_OPTS = ({
    modules,
    $swiper,
    $prevButton,
    $nextButton,
    $pagination,
    updateCallback,
    isPrefersReducedMotion = false
}) => {
    return {
        modules: modules,
        speed: isPrefersReducedMotion ? 0 : 400,
        effect: isPrefersReducedMotion ? 'fade' : 'slide',
        loop: true,
        slidesPerView: 1,
        navigation: {
            prevEl: $prevButton,
            nextEl: $nextButton
        },
        pagination: {
            el: $pagination,
            type: 'fraction',
            formatFractionCurrent: (number) => {
                return number < 10 ? `0${number}` : number;
            },
            formatFractionTotal: (number) => {
                return number < 10 ? `0${number}` : number;
            }
        },
        autoplay: isPrefersReducedMotion
            ? false
            : {
                  delay: 4000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
              },
        on: {
            init: updateCallback ? updateCallback : () => {},
            breakpoint: updateCallback ? updateCallback : () => {},
            destroy: updateCallback ? updateCallback : () => {},
            autoplayTimeLeft: (s, time, progress) => {
                $swiper.style.setProperty('--autoplay-progress', 1 - progress);
            }
        }
    };
};
